module.exports = __webpack_public_path__ + "img/marketCopy.5b2f0bba.svg";